import { IMonitorable } from '../monitoring/IMonitorable';
import type { Job } from '../job/Job';

export enum CollectionStatus {
  Unknown = "Unknown",
  New = "New",
  Syncing = "Syncing",
  Paused = "Paused",
  Initializing = "Initializing",
  Processing = "Processing",
  Processed = "Processed"
}

// Expose as browser global so cross-module bare references resolve
(window as any).CollectionStatus = CollectionStatus;

export enum PIIDetectionMode {
  Standard = "gate",
  Enhanced = "gliner"
}

export interface ICollection extends IMonitorable {
  id: string;
  status: CollectionStatus;
  projectId: string;
  custodian: string;
  name: string;
  description: string;
  ritm: string;
  evidence: string;
  release: string;
  extractAttachmentAndEmbeddedDocumentsFromEmails: boolean;
  extractImagesFromEmails: boolean;
  extractFromContainers: boolean;
  extractDocumentsFromFiles: boolean;
  extractImagesFromFiles: boolean;
  imagePresentationsWithNotes: boolean;
  numQueued: number;
  numProcessed: number;
  bytesProcessed: number;
  processingSource: any;
  processingOutput: any;
  processingStart: Date;
  processingEnd: Date;
  pdfQueued: number;
  nlpQueued: number;
  ocrQueued: number;
  audioQueued: number;
  job: Job;
  piiDetectionMode: PIIDetectionMode;
}

export class Collection implements ICollection {
  public id: string;
  public projectId: string;

  public status: CollectionStatus;
  public job: Job;

  public custodian: any;
  public name: string;
  public description: string;
  public ritm: string;
  public evidence: string;
  public release: string;
  public extractAttachmentAndEmbeddedDocumentsFromEmails: boolean;
  public extractImagesFromEmails: boolean;
  public extractFromContainers: boolean;
  public extractDocumentsFromFiles: boolean;
  public extractImagesFromFiles: boolean;
  public imagePresentationsWithNotes: boolean;
  public cancelTranscription: boolean;
  public cancelExtractEntities: boolean;
  public cancelPdf: boolean;
  public cancelOcr: boolean;
  public piiDetectionMode: PIIDetectionMode;
  public numQueued: number;
  public numProcessed: number;
  public bytesProcessed: number;
  public processingSource: any;
  public processingOutput: any;
  public processingStart: Date;
  public processingEnd: Date;
  public pdfQueued: number;
  public nlpQueued: number;
  public ocrQueued: number;
  public audioQueued: number;

  constructor(projectId: string, custodian: any, name: string, description: string, ritm: string, evidence: string, release: string, extractFromContainers: boolean, extractAttachmentAndEmbeddedDocumentsFromEmails: boolean, extractImagesFromEmails: boolean, extractDocumentsFromFiles: boolean, extractImagesFromFiles: boolean, imagePresentationsWithNotes: boolean, cancelTranscription: boolean = false, cancelExtractEntities: boolean = false, cancelPdf: boolean = false, cancelOcr: boolean = false, piiDetectionMode: PIIDetectionMode = PIIDetectionMode.Standard) {
    this.projectId = projectId;
    this.custodian = custodian;
    this.name = name;
    this.description = description;
    this.ritm = ritm;
    this.evidence = evidence;
    this.release = release;
    this.extractFromContainers = extractFromContainers;
    this.extractAttachmentAndEmbeddedDocumentsFromEmails = extractAttachmentAndEmbeddedDocumentsFromEmails;
    this.extractImagesFromEmails = extractImagesFromEmails;
    this.extractDocumentsFromFiles = extractDocumentsFromFiles;
    this.extractImagesFromFiles = extractImagesFromFiles;
    this.imagePresentationsWithNotes = imagePresentationsWithNotes;
    this.cancelTranscription = cancelTranscription;
    this.cancelExtractEntities = cancelExtractEntities;
    this.cancelPdf = cancelPdf;
    this.cancelOcr = cancelOcr;
    this.piiDetectionMode = piiDetectionMode;
  }
}
